'use client'
import React from 'react'
import dynamic from 'next/dynamic'

// Keep critical above-the-fold components loaded immediately
import HeroSection from '@/components/Home/HeroSection'

// Lazy load below-the-fold components for better performance
const DemoSection = dynamic(() => import('@/components/demo/DemoSection'), {
  loading: () => <div className="min-h-[750px]" /> // Prevent layout shift
})
const Ecosysystem = dynamic(() => import('@/components/Home/Ecosysystem'))
const PricingSection = dynamic(() => import('@/components/Home/PricingSection'))
const CTASection = dynamic(() => import('@/components/Home/CTASection'))
const TestimonialsSection = dynamic(() => import('@/components/Home/TestimonialsSection'))
const ContactSection = dynamic(() => import('@/components/Home/ContactSection'))
const Footer = dynamic(() => import('@/components/Footer'))

export default function Home() {
	return (
		<>
			<HeroSection />
			<DemoSection />
			<Ecosysystem />
			<PricingSection />
			<CTASection />
			<TestimonialsSection />
			<ContactSection />
			<Footer />
		</>
	)
}
